import { UploadedFont } from 'Shared/model/venueSettings';


export type UploadedFace = Pick<UploadedFont,'family'|'weight'|'weightMax'|'style'>;


/* The css font-weight of an uploaded font: one weight, or the range a variable font covers */
export function fontWeightRange(face:UploadedFace)
{
	return face.weightMax == undefined ? `${face.weight}` : `${face.weight} ${face.weightMax}`;
}

/* Whether two uploaded fonts are the same face of the same family - an upload of one replaces the other */
export function sameFontFace(a:UploadedFace, b:UploadedFace)
{
	return a.family.toLowerCase() == b.family.toLowerCase() && a.weight == b.weight
		&& a.weightMax == b.weightMax && a.style == b.style;
}

/* How a face is named beside its family: '700 italic', or '100–900' for a variable font */
export function faceLabel(face:UploadedFace)
{
	const weight = face.weightMax == undefined ? `${face.weight}` : `${face.weight}–${face.weightMax}`;
	return face.style == 'italic' ? `${weight} italic` : weight;
}
